<script setup>
import { getI18n } from '@/plugins/i18n'

import { useDetectDevice } from '@/composables/device'

import NavigateBack from '@/components/shared/NavigateBack.vue'

defineProps({
  // { name, src }, null when closed
  image: {
    type: Object,
    default: null,
  },
})
const emit = defineEmits(['close'])

const i18n = getI18n()
const { isMobile } = useDetectDevice()
</script>

<template>
  <q-dialog
    :model-value="image !== null"
    :maximized="isMobile"
    class="dialog-xs"
    @hide="emit('close')"
  >
    <q-card v-if="image" class="dialog-card-flex image-preview" :class="{ 'image-preview--desktop': !isMobile }">
      <navigate-back :text="image.name" @cancel="emit('close')">
        <template #right>
          <q-btn
            flat
            round
            icon="mdi-download"
            :href="image.src"
            :download="image.name"
          >
            <q-tooltip>{{ i18n.t('common.download') }}</q-tooltip>
          </q-btn>
        </template>
      </navigate-back>
      <q-card-section class="col flex flex-center image-preview__body">
        <img :src="image.src" :alt="image.name" class="image-preview__image">
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.image-preview--desktop {
  height: 85vh;
}

.image-preview__body {
  min-height: 0;
  background: $grey-2;
}

.image-preview__image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: .25rem;
  box-shadow: 0 .25rem 1rem rgba(0, 0, 0, 0.15);
}
</style>
